import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function workorderAttachmentsReducer(state = initialState.workorderAttachments, action) {
  switch (action.type) {
    case types.CLEAR_WORKORDER_ATTACHMENTS:
      return {};
    case types.GET_WORKORDER_ATTACHMENTS_SUCCESS:
      return action.result;
    default:
      return state;
  }
}
